import { ERROR_SUCCESS, ERROR_FAILURE } from '../actions/types';

const initialState = false;

export default function errorReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ERROR_SUCCESS:
      return payload;
    case ERROR_FAILURE:
      return false;

    default:
      return state;
  }
}
